/* eslint-disable complexity */
/* eslint-disable no-magic-numbers */
import React from 'react';
import { Accordion } from 'carbon-react/lib/components/accordion';
import Typography from 'carbon-react/lib/components/typography';

import { ActiveMode, COA_TYPE, COADisplayAccount } from '../../types';
import { CategoryTable } from '../category-table/category-table';
import { useCategoryDragDrop } from '../../hooks/useCategoryDragDrop';
import { useLocalisedConstantsContext } from '../../../../../localisation/src/core/localised-constants-context';

import * as styles from './category-section.scss';

export interface Props {
  nodeIdsWithParentIds: Map<string, string[]>;
  data: COADisplayAccount[];
  categoryName: string;
  isBalanceSheet: boolean;
  activeMode?: ActiveMode;
  accountNameMap?: Record<string, string>;
  onDragAndDropUpdate: (tree: COADisplayAccount) => void;
  accountsTree: COADisplayAccount | null;
  isUpdatingStructure: boolean;
  handleReorder: (draftAccountsTree: COADisplayAccount, coaType: COA_TYPE) => Promise<void>;
}

export const CategorySection = ({
  nodeIdsWithParentIds,
  data,
  categoryName,
  isBalanceSheet,
  activeMode,
  accountNameMap,
  onDragAndDropUpdate,
  accountsTree,
  isUpdatingStructure,
  handleReorder
}: Props) => {
  const { accountCategoryNames } = useLocalisedConstantsContext();

  const drag = useCategoryDragDrop({
    data,
    categoryName,
    accountsTree,
    nodeIdsWithParentIds,
    onDragAndDropUpdate,
    isUpdatingStructure,
    onManualMoveUpdate: handleReorder,
    isBalanceSheet
  });

  return (
    <div className={styles.accordionContainer}>
      <Accordion
        size="small"
        aria-labelledby={`${categoryName}-summary`}
        defaultExpanded
        title={
          <Typography fontSize="16px" fontWeight="500" mb={0}>
            {(accountCategoryNames as Record<string, string>)[categoryName]}
          </Typography>
        }
      >
        <CategoryTable
          tableData={data}
          accountNameMap={accountNameMap}
          isBalanceSheet={isBalanceSheet}
          activeMode={activeMode}
          categoryName={categoryName}
          drag={drag}
          isUpdatingStructure={isUpdatingStructure}
        />
      </Accordion>
    </div>
  );
};
